import {
  NEW_VERSION_DETECTED,
  CHANGE_VERSION,
  RESET_SYSTEM_ACTION,
  RESET_SYSTEM,
  SET_DOCUMENT_TITLE,
  SAVE_DOCUMENT_TITLE
} from '../actions/system'

import {
  CHANGE_HOME_NAV,
  CHANGE_NOTIFICATIONS_NAV,
  CHANGE_PROFILE_NAV,
  CHANGE_NAVIGATION_STATE
} from '../actions/navigationChange'
import { router, NotificationNavRouter, ProfileNavRouter } from '@/router'

const getDefaultState = () => ({
  newVersion: false,
  activeNavigation: 'home',
  documentTitle: undefined
})

const state = getDefaultState()

const getters = {
  isHomeNavActive: state => state.activeNavigation === 'home',
  isNotificationNavActive: state => state.activeNavigation === 'notifications',
  isProfileNavActive: state => state.activeNavigation === 'profile',
  getActiveNav: state => state.activeNavigation,
  getDocumentTitleName: state => state.documentTitle
}

const actions = {
  [NEW_VERSION_DETECTED]: ({ commit }, data) => {
    commit(CHANGE_VERSION)
  },
  [CHANGE_HOME_NAV]: ({ commit }) => {
    if (router.currentRoute.name) window.history.replaceState({}, document.title, router.currentRoute.path)
    commit(CHANGE_NAVIGATION_STATE, 'home')
  },
  [CHANGE_NOTIFICATIONS_NAV]: ({ commit }) => {
    if (NotificationNavRouter.currentRoute.name) window.history.replaceState({}, document.title, NotificationNavRouter.currentRoute.path)
    commit(CHANGE_NAVIGATION_STATE, 'notifications')
  },
  [CHANGE_PROFILE_NAV]: ({ commit }) => {
    if (ProfileNavRouter.currentRoute.name) window.history.replaceState({}, document.title, ProfileNavRouter.currentRoute.path)
    commit(CHANGE_NAVIGATION_STATE, 'profile')
  },
  [RESET_SYSTEM_ACTION]: ({commit}) => {
    commit(RESET_SYSTEM)
  },
  [SET_DOCUMENT_TITLE]: ({commit}, documentTitle) => {
    commit(SAVE_DOCUMENT_TITLE, documentTitle)
  }
}

const mutations = {
  [CHANGE_VERSION]: state => {
    state.newVersion = true
  },
  [CHANGE_NAVIGATION_STATE]: (state, newState) => {
    state.activeNavigation = newState
  },
  [RESET_SYSTEM]: (state) => {
    Object.assign(state, getDefaultState())
  },
  [SAVE_DOCUMENT_TITLE]: (state, titleName) => {
    state.documentTitle = titleName
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system.js